<div>
    <div class="property-card clip6 position-relative prop-card fw-normal primary-border rounded-1 clip6-corner">
        <h6 class="mb-4 primary-text">
            <ng-content select="[title]"></ng-content>
        </h6>

        <ng-content select="[content]"></ng-content>
    </div>

    
</div>